import React from 'react';
import Modal from '@mui/material/Modal';
import CloseIcon from '@src/componentsNew/Icons/Icons/CloseIcon';

import "./basic-modal-style.scss";

import Typography from '@src/componentsNew/Typography/Typography';
import Button from '@src/componentsNew/Buttons/Button';

interface IProps {
  modalId?: string;
  cName?: string;
  title?: string;
  titleColor?: string;
  content?: React.ReactNode | string;
  contentColor?: string;
  open: boolean;
  onClose?: any;
  onAction?: any;
  closeButtonText?: string;
  onClickCloseButton?: any; // 모달 하단의 closeTextButton클릭 시 모달 닫기와 다르게 동작해야 할 경우
  actionButtonText?: string;
  showCloseIcon: boolean; // 상단 x 버튼
}

const BasicModal = ({
  modalId,
  cName,
  title,
  titleColor,
  content,
  contentColor,
  open,
  onClose,
  onAction,
  closeButtonText,
  onClickCloseButton,
  actionButtonText,
  showCloseIcon
}: IProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
    >
      <div id={modalId} className={`basic-modal-wrapper ${cName ? cName : ''}`}>
        {
          title || showCloseIcon ?
            <div className={`modal-title-area ${showCloseIcon ? 'between' : ''}`}>
              <Typography
                cName="title-text"
                variant="subtitle1"
                component="p"
                style={{ color: titleColor ? titleColor : "#212121" }}>
                {title}
              </Typography>

              {
                showCloseIcon &&
                <CloseIcon cName="close-btn" onClick={onClose} />
              }
            </div> : null
        }

        {
          content && typeof content !== 'string' ? (
            content
          ) : (
            content && typeof content === 'string' ? (
              <Typography
                cName="content-text"
                variant="body3"
                component="p"
                style={{ color: contentColor ? contentColor : "#11141D99" }}>
                {content}
              </Typography>
            ) : null
          )
        }

        {
          closeButtonText || actionButtonText ?
            <div className="btn-wrapper">
              {
                closeButtonText ?
                  <Button cName="close-btn" size="medium" variant="contained" onClick={onClickCloseButton ? onClickCloseButton : onClose}>
                    {closeButtonText}
                  </Button> : null
              }

              {
                actionButtonText ?
                  <Button cName="action-btn" size="medium" variant="contained" onClick={onAction}>
                    {actionButtonText}
                  </Button> : null
              }
            </div> : null
        }
      </div>
    </Modal >
  );
};

export default BasicModal;
